var image_viewer_rtlignore_default = {
  "fontElementMap": "_3IRYy",
  "imageContainer": "n8j-U",
  "expandButton": "-d0kF",
  "expandIcon": "_34eAR",
  "pointer": "HKd75",
  "imageWrapper": "soNkr",
  "imageRatio": "k0QAQ",
  "image": "-TIxq",
  "imageOverlay": "wkKPB",
  "imagePreload": "xV8rI",
  "imageHighres": "zPlDn",
  "onlyHighRes": "yjHV9",
  "image_loading": "gX9-j"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
